module.exports = __webpack_public_path__ + "static/media/video_hotspot.6cf008e5.png";